import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { post } from "../../lib/request";

export const createAlertGroup = createAsyncThunk(
  "alertGroup/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await post("alert-groups", payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to create group");
    }
  }
);

const alertGroupCreateSlice = createSlice({
  name: "alertGroupCreate",
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetAlertGroupCreate: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAlertGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAlertGroup.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createAlertGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetAlertGroupCreate } = alertGroupCreateSlice.actions;
export default alertGroupCreateSlice.reducer;
